"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStaticImage = exports.GoogleMapType = void 0;
var GoogleMapType;
(function (GoogleMapType) {
    GoogleMapType[GoogleMapType["ROADMAP"] = 0] = "ROADMAP";
    GoogleMapType[GoogleMapType["SATELLITE"] = 1] = "SATELLITE";
})(GoogleMapType = exports.GoogleMapType || (exports.GoogleMapType = {}));
exports.getStaticImage = function (district, googleApiKey) {
    var keyword = 'hong kong';
    var zoom = 9;
    if (district && district.area === null) {
        keyword = district.name + " " + keyword;
        zoom = 11;
    }
    if (district && district.area !== null) {
        keyword = district.name + " " + keyword;
        zoom = 14;
    }
    var mapConfig = [
        ['center', keyword],
        ['zoom', "" + zoom],
        ['size', '300x300'],
        ['maptype', 'roadmap'],
        ['style', 'feature:all|element:labels'],
        ['key', googleApiKey],
    ];
    var endpoint = 'https://maps.googleapis.com/maps/api/staticmap';
    return endpoint + "?" + mapConfig.map(function (it) { return it[0] + "=" + it[1]; }).join('&');
};
